// GENERATE BY SVGR, DON NOT EDIT IT MANUALLY
import React from 'react';
interface SvgCompProps {
    className?: string;
    style?: React.CSSProperties;
    onClick?: React.MouseEventHandler<SVGSVGElement>;
}
const SvgArrowRight = (props: SvgCompProps, ref: React.Ref<SVGSVGElement>) => {
    const svgProps = {
        width: '1em',
        height: '1em',
        fill: 'currentColor',
        'aria-hidden': true,
        focusable: false,
        ...props
    };
    return (
        <svg viewBox="0 0 1024 1024" {...svgProps} ref={ref}>
            <path d="M216.48 544h513.76L542.72 731.68a32 32 0 0 0 0 45.12 32 32 0 0 0 22.56 9.44A32 32 0 0 0 588 776.8l242.08-242.08c.96-.96 1.6-1.92 2.4-2.88a24 24 0 0 0 1.6-2.08 23 23 0 0 0 1.92-3.36s.8-1.44 1.12-2.08a29 29 0 0 0 1.12-4v-2.08a27.5 27.5 0 0 0 0-6.24 27.5 27.5 0 0 0 0-6.24v-2.08a29 29 0 0 0-1.12-4s-.8-1.28-1.12-2.08a23 23 0 0 0-1.92-3.36 24 24 0 0 0-1.6-2.08c0-.96-1.44-1.92-2.4-2.88L588 247.2a32 32 0 1 0-45.28 45.12L730.24 480H216.48a32 32 0 0 0 0 64" />
        </svg>
    );
};
SvgArrowRight.displayName = 'SvgArrowRight';
export default React.memo(React.forwardRef(SvgArrowRight));
